import { createAsyncThunk } from '@reduxjs/toolkit'
import AxiosClient from '../AxiosClient'
import { OMS_BASE } from 'src/utils/constants'

// ===================================================================
// Package APIs — CRUD for standalone package templates/presets
// (not tied to any specific order)
// ===================================================================

/**
 * Fetch list of all saved packages (with search, pagination, filters)
 * GET /oms/packages?search=...&page=...&limit=...
 */
export const getPackageListAsync = createAsyncThunk(
  'oms/getPackageListAsync',
  async function (
    params: {
      page: number
      limit?: number
      order_by?: string
      sort_by?: string
      search?: string
      id?: number
      is_active?: boolean
    },
    toolkit
  ) {
    const query = new URLSearchParams()
    // Required
    query.append('page', String(params.page))
    // Optional
    if (params.limit) query.append('limit', String(params.limit))
    if (params.order_by) query.append('order_by', params.order_by)
    if (params.sort_by) query.append('sort_by', params.sort_by)
    if (params.search) query.append('search', params.search)
    if (params.id) query.append('id', String(params.id))
    if (params.is_active !== undefined) query.append('is_active', String(params.is_active))

    const url = `${OMS_BASE}/packages?${query.toString()}`
    return await AxiosClient('GET', url, [], toolkit, [], toolkit.signal)
  }
)

/**
 * Create a new standalone package preset
 * POST /oms/packages
 */
export const createPackageAsync = createAsyncThunk(
  'oms/createPackageAsync',
  async function (payload: any, toolkit) {
    const url = `${OMS_BASE}/packages`
    return await AxiosClient('POST', url, payload, toolkit, [])
  }
)

/**
 * Update an existing package preset by its ID
 * PUT /oms/packages/:id
 */
export const updatePackageAsync = createAsyncThunk(
  'oms/updatePackageAsync',
  async function (payload: { id: number; payloadupdate: any }, toolkit) {
    const url = `${OMS_BASE}/packages/${payload?.id}`
    return await AxiosClient('PUT', url, payload.payloadupdate, toolkit, [])
  }
)

/**
 * Delete a package preset by its ID
 * DELETE /oms/packages/:id
 */
export const deletePackageAsync = createAsyncThunk(
  'oms/deletePackageAsync',
  async function (payload: { id: number }, toolkit) {
    const url = `${OMS_BASE}/packages/${payload.id}`
    return await AxiosClient('DELETE', url, [], toolkit, [])
  }
)
